import styled from '@emotion/styled';
import { bodyB, bodyM, subTitle3 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { device } from '@/styles/themes';

export const Wrapper = styled.section<{ hideFloating: boolean }>`
  display: ${({ hideFloating }) => (hideFloating ? 'none' : 'flex')};
  @media ${device.desktop} {
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    position: fixed;
    bottom: 12px;
    z-index: 2;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.76);
  backdrop-filter: blur(10px);
  padding: 14px 16px;
  z-index: 20;
  ${bodyB};
  color: ${vars.neutral[0]};
  text-align: left;
  @media ${device.desktop} {
    margin: 0 auto 12px auto;
    width: 70%;
    max-width: 612px;
    padding: 20px;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.24);
    border-radius: 8px;
    ${bodyB};
  }
`;
export const WebinarInfo = styled.div``;
export const Lecturer = styled.span`
  ${bodyM};
  color: ${vars.neutral[50]} !important;
  font-size: 13px;
  @media ${device.desktop} {
  }
`;
export const DateTime = styled.div`
  ${bodyM};
  font-size: 16px;
  color: ${vars.neutral[0]} !important;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-style: normal;
  font-weight: 600;
  line-height: 160%; /* 28.8px */
  @media ${device.desktop} {
    font-size: 18px;
  }
`;

export const ApplyBtn = styled.button`
  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  width: 140px;
  height: 54px;
  cursor: pointer;
  border: none;
  border-radius: 38px;
  ${subTitle3};
  font-size: 16px;
  color: ${vars.neutral[0]} !important;
  background-color: ${vars.brand.default};
  @media ${device.desktop} {
    border-radius: 48px;
    width: 224px;
    height: 48px;
    ${bodyB};
  }
`;
